import React from 'react'

// styles
import { bannerContainer } from 'styles/v2/pages/profile'
import { ImageFit } from 'components/commons/images/ImageFit.component'
import Image from 'next/image'
import { Icon } from 'public/assets/v2/images/icons'

interface Props {
  src: string
  alt: string
  priority?: boolean
  showEditButton?: boolean
  onClick?: () => void
}

export const CoverImage: React.FC<Props> = ({
  src,
  alt,
  priority,
  showEditButton,
  onClick,
}) => {
  const randomeKey = Math.random().toString(36).substring(7)
  return (
    <div className={bannerContainer} onClick={onClick}>
      {/* <div style={{ position: 'relative' }}> */}
      <Image src={src} alt={alt} priority={priority} key={alt} fill={true} />
      <ImageFit
        src={src}
        alt={alt}
        priority={priority}
        objectFit="cover"
        key={randomeKey}
      />
      {showEditButton && (
        <div
          style={{
            position: 'absolute',
            top: '25px',
            right: '25px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '12px',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            width: '40px',
            height: '40px',
            padding: '10px',
            gap: '10px',
          }}
        >
          <Icon.EditIconPen
            className="cl-white-primary"
            style={{ width: '20px', height: '20px' }}
          />
        </div>
      )}

      {/* </div> */}
    </div>
  )
}
